// extracted by mini-css-extract-plugin
export var actionButton = "_el-0";
export var attachmentLine = "_el-1";
export var fileInput = "_el-2";
export var fileUploadWrapper = "_el-4";
export var footer = "_el-3";
export var modalContent = "_el-5";
export var paperclip = "_el-6";
export var quillEditor = "_el-7";